import React, { useEffect, useState } from 'react';
import CircleButton, { getCircleButtonClass, } from 'components/v2/buttons/CircleButton';
import CalendarIcon from 'components/v2/icons/CalendarIcon';
import CheckIcon from 'components/v2/icons/CheckIcon';
import { useTranslation } from 'react-i18next';
import { sluggify } from 'utils/localization/utils';
import ShipmentDatesModal from 'components/modules/shipments/ShipmentDatesModal';
import { showToast } from 'stores/ToastStore';
export default function DateNextSteps({ item, shipment }) {
    const { t } = useTranslation();
    const [showModal, setShowModal] = useState(false);
    const renderIcon = () => {
        return !item.complete ? (React.createElement(CalendarIcon, { type: "solid", className: "w-5 h-5" })) : (React.createElement("div", { "data-testid": "div-bba6d2d9", className: getCircleButtonClass({ size: 'small', color: 'brand' }) },
            React.createElement(CheckIcon, null)));
    };
    const handleNextStepsDateSave = () => {
        showToast(t('SHIPMENT_NEXT_STEPS_UPDATE_SUCCESSFUL'), null, 'success');
        setShowModal(false);
    };
    const handleNextStepsDateSaveFail = (e) => {
        showToast(t('FAILED_SHIPMENT_NEXT_STEPS_UPDATE'), null, 'error');
        setShowModal(false);
    };
    return ((React.createElement("div", { "data-testid": "div-c4d45ba8" },
        React.createElement("div", { "data-testid": "div-2447baec", className: "flex justify-between text-sm text-gray-700  py-1 items-center" },
            React.createElement("span", { "data-testid": "span-ae954506" }, t(sluggify(item.field))),
            React.createElement(CircleButton, { dataTestId: "CircleButton-0eaba379", size: "small", disabled: item.complete, onClick: () => setShowModal(true) }, renderIcon())),
        showModal && (React.createElement(ShipmentDatesModal, { field: item.field, currentFieldValue: shipment[item.field], shipment: shipment, onSuccess: handleNextStepsDateSave, onFail: handleNextStepsDateSaveFail, onHide: () => setShowModal(false), show: showModal })))));
}
